export const startupTimings = {
  revealDelayMs: 250,
  minimumVisibleMs: 500,
  exitMs: 160,
  longWaitMs: 8_000,
  recoveryWaitMs: 20_000,
  attemptTimeoutMs: 20_000,
  autoRetryBaseMs: 3_000,
  autoRetryCapMs: 30_000,
} as const;

export type StartupPhase =
  | 'concealed'
  | 'revealPending'
  | 'loadingVisible'
  | 'longWaitVisible'
  | 'recoveryVisible'
  | 'exiting'
  | 'appVisible';

export type BootstrapFailureKind =
  | 'network'
  | 'request-timeout'
  | 'attempt-timeout'
  | 'http'
  | 'payload'
  | 'parse'
  | 'patch'
  | 'abort'
  | 'unknown';

export type BootstrapFailure = {
  kind: BootstrapFailureKind;
  cause: unknown;
  attemptId: number;
  elapsedMs: number;
  status?: number;
};

export type PresentationInput = {
  nowMs: number;
  ready: boolean;
  visibilityOpportunityAt: number | null;
  exitComplete: boolean;
};

export function resolveStartupPhase(input: PresentationInput): StartupPhase {
  const { nowMs, ready, visibilityOpportunityAt, exitComplete } = input;
  if (ready) {
    if (exitComplete || visibilityOpportunityAt == null) return 'appVisible';
    if (nowMs >= visibilityOpportunityAt + startupTimings.minimumVisibleMs) return 'exiting';
  }
  if (visibilityOpportunityAt == null) {
    return nowMs < startupTimings.revealDelayMs ? 'concealed' : 'revealPending';
  }
  if (nowMs >= startupTimings.recoveryWaitMs) return 'recoveryVisible';
  if (nowMs >= startupTimings.longWaitMs) return 'longWaitVisible';
  return 'loadingVisible';
}

export function getStartupTitle(phase: StartupPhase, retrying: boolean) {
  if (retrying) return '正在重新准备';
  if (phase === 'recoveryVisible') return '很快就好';
  if (phase === 'longWaitVisible') return '很快就好';
  return '正在准备你的空间';
}

export function getAutoRetryDelay(failureCount: number, random = Math.random) {
  const base = Math.min(
    startupTimings.autoRetryBaseMs * (2 ** Math.max(0, failureCount - 1)),
    startupTimings.autoRetryCapMs,
  );
  return Math.round(base * (0.8 + random() * 0.4));
}

export function getExitDuration(reducedMotion: boolean) {
  return reducedMotion ? 0 : startupTimings.exitMs;
}
